import React from 'react';
export function HowItWorks() {
  return <section className="w-full py-20 px-6" style={{
    backgroundColor: '#FAFAF8'
  }} data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-110">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase mb-4" style={{
          color: '#FF5A5F',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-111">
            Cómo funciona
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight" style={{
          color: '#1A1A1A',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }} data-id="element-112">
            3 pasos para operar en modo automático
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-113">
          {/* Step 1 */}
          <div className="flex flex-col items-center text-center" data-id="element-114">
            <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-extrabold text-2xl mb-5 shadow-md" style={{
            backgroundColor: '#FF5A5F',
            fontFamily: 'Plus Jakarta Sans, sans-serif'
          }} aria-label="Paso 1" data-id="element-115">
              1
            </div>
            <div className="text-4xl mb-4" role="img" aria-label="Descarga" data-id="element-116">
              📥
            </div>
            <h3 className="text-xl font-bold mb-3" style={{
            color: '#1A1A1A',
            fontFamily: 'Plus Jakarta Sans, sans-serif'
          }} data-id="element-117">
              Descarga y copia
            </h3>
            <p style={{
            color: '#6B7280',
            fontFamily: 'Inter, sans-serif'
          }} className="text-base leading-relaxed" data-id="element-118">
              Descarga el sistema y copia las plantillas de mensajes
              programados. Todo está listo para usar.
            </p>
          </div>

          {/* Connector line (desktop only) */}
          <div className="hidden md:flex items-start justify-center pt-8" data-id="element-119">
            <div className="w-full h-0.5 mt-8" style={{
            backgroundColor: '#E8E0D8'
          }} data-id="element-120" />
          </div>

          {/* Step 2 */}
          <div className="flex flex-col items-center text-center" data-id="element-121">
            <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-extrabold text-2xl mb-5 shadow-md" style={{
            backgroundColor: '#FF5A5F',
            fontFamily: 'Plus Jakarta Sans, sans-serif'
          }} aria-label="Paso 2" data-id="element-122">
              2
            </div>
            <div className="text-4xl mb-4" role="img" aria-label="Personaliza" data-id="element-123">
              🏠
            </div>
            <h3 className="text-xl font-bold mb-3" style={{
            color: '#1A1A1A',
            fontFamily: 'Plus Jakarta Sans, sans-serif'
          }} data-id="element-124">
              Personaliza tu guía
            </h3>
            <p style={{
            color: '#6B7280',
            fontFamily: 'Inter, sans-serif'
          }} className="text-base leading-relaxed" data-id="element-125">
              Personaliza la Guía de Check-in con las fotos de tu propiedad
              siguiendo nuestras instrucciones paso a paso.
            </p>
          </div>

          {/* Connector line (desktop only) */}
          <div className="hidden md:flex items-start justify-center pt-8" data-id="element-126">
            <div className="w-full h-0.5 mt-8" style={{
            backgroundColor: '#E8E0D8'
          }} data-id="element-127" />
          </div>

          {/* Step 3 */}
          <div className="flex flex-col items-center text-center" data-id="element-128">
            <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-extrabold text-2xl mb-5 shadow-md" style={{
            backgroundColor: '#FF5A5F',
            fontFamily: 'Plus Jakarta Sans, sans-serif'
          }} aria-label="Paso 3" data-id="element-129">
              3
            </div>
            <div className="text-4xl mb-4" role="img" aria-label="Activa" data-id="element-130">
              🚀
            </div>
            <h3 className="text-xl font-bold mb-3" style={{
            color: '#1A1A1A',
            fontFamily: 'Plus Jakarta Sans, sans-serif'
          }} data-id="element-131">
              Activa y olvídate
            </h3>
            <p style={{
            color: '#6B7280',
            fontFamily: 'Inter, sans-serif'
          }} className="text-base leading-relaxed" data-id="element-132">
              Activa la automatización en tu plataforma de rentas cortas y deja
              que el sistema trabaje por ti.
            </p>
          </div>
        </div>

        {/* Time callout */}
        <div className="mt-12 rounded-2xl p-6 text-center" style={{
        backgroundColor: '#F5F0EB'
      }} data-id="element-133">
          <p className="text-lg font-bold" style={{
          color: '#1A1A1A',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }} data-id="element-134">
            ⏱️ Tiempo total de configuración: menos de 10 minutos
          </p>
          <p style={{
          color: '#6B7280',
          fontFamily: 'Inter, sans-serif'
        }} className="text-sm mt-1" data-id="element-135">
            Con las herramientas gratuitas que ya tienes en la App de Airbnb
          </p>
        </div>
      </div>
    </section>;
}